import ChatPanelItem from './ChatPanelItem'

export default ChatPanelItem
